import script from "./AssessmentScores.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentScores.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentScores.vue?vue&type=style&index=0&id=315f4c4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315f4c4e"]])

export default __exports__